{
    "1_1_1_1_1_1_1_1_1_1_1_1": {
        "name": "Chromatic",
        "source": "https://en.wikipedia.org/wiki/Chromatic_scale"
    },
    "2_2_1_2_2_2_1": {
        "name": "Major (Ionian)",
        "source": "https://en.wikipedia.org/wiki/Major_scale"
    },
    "2_1_2_2_1_2_2": {
        "name": "Natural Minor (Aeolian)",
        "source": "https://en.wikipedia.org/wiki/Minor_scale"
    },
    "2_1_2_2_2_1_2": {
        "name": "Harmonic Minor",
        "source": "https://en.wikipedia.org/wiki/Minor_scale#Harmonic_minor_scale"
    },
    "2_1_2_2_2_2_1": {
        "name": "Melodic Minor (Ascending)",
        "source": "https://en.wikipedia.org/wiki/Minor_scale#Melodic_minor_scale"
    },
    "1_2_2_1_2_2_2": {
        "name": "Dorian",
        "source": "https://en.wikipedia.org/wiki/Dorian_mode"
    },
    "1_2_2_2_2_2_1": {
        "name": "Phrygian",
        "source": "https://en.wikipedia.org/wiki/Phrygian_mode"
    },
    "2_2_2_1_2_2_1": {
        "name": "Lydian",
        "source": "https://en.wikipedia.org/wiki/Lydian_mode"
    },
    "2_2_1_2_2_1_2": {
        "name": "Mixolydian",
        "source": "https://en.wikipedia.org/wiki/Mixolydian_mode"
    },
    "1_2_1_2_1_2_2": {
        "name": "Locrian",
        "source": "https://en.wikipedia.org/wiki/Locrian_mode"
    },
    "2_2_3_2_3": {
        "name": "Pentatonic Major",
        "source": "https://en.wikipedia.org/wiki/Pentatonic_scale#Major_pentatonic_scale"
    },
    "3_2_2_3_2": {
        "name": "Pentatonic Minor",
        "source": "https://en.wikipedia.org/wiki/Pentatonic_scale#Minor_pentatonic_scale"
    },
    "3_2_1_1_3_2": {
        "name": "Blues Scale",
        "source": "https://en.wikipedia.org/wiki/Blues_scale"
    },
    "2_1_3_1_1_3_1": {
        "name": "Hungarian Minor",
        "source": "https://en.wikipedia.org/wiki/Hungarian_minor_scale"
    },
    "1_3_1_2_1_3_1": {
        "name": "Hungarian Major",
        "source": "https://en.wikipedia.org/wiki/Hungarian_major_scale"
    },
    "1_4_2_1_4": {
        "name": "Hirajoshi",
        "source": "https://en.wikipedia.org/wiki/Hirajōshi_scale"
    },
    "2_3_2_2_3": {
        "name": "Yo Scale",
        "source": "https://en.wikipedia.org/wiki/Yo_scale"
    },
    "4_2_1_4_1": {
        "name": "In Scale",
        "source": "https://en.wikipedia.org/wiki/In_scale"
    },
    "1_4_1_4_2": {
        "name": "Insen Scale",
        "source": "https://en.wikipedia.org/wiki/Insen_scale"
    },
    "2_1_4_1_4": {
        "name": "Iwato Scale",
        "source": "https://en.wikipedia.org/wiki/Iwato_scale"
    },
    "3_1_3_1_3_1": {
        "name": "Whole-Tone",
        "source": "https://en.wikipedia.org/wiki/Whole_tone_scale"
    },
    "2_1_1_1_2_1_1_1_2": {
        "name": "Bebop Dominant",
        "source": "https://en.wikipedia.org/wiki/Bebop_scale#Bebop_dominant_scale"
    },
    "2_2_1_2_1_1_2_1": {
        "name": "Bebop Major",
        "source": "https://en.wikipedia.org/wiki/Bebop_scale#Bebop_major_scale"
    },
    "2_1_2_2_1_1_2_1": {
        "name": "Bebop Minor",
        "source": "https://en.wikipedia.org/wiki/Bebop_scale#Bebop_dorian_scale"
    },
    "1_2_1_2_1_2_1_2": {
        "name": "Diminished (Half-Whole)",
        "source": "https://en.wikipedia.org/wiki/Octatonic_scale"
    },
    "2_1_2_1_2_1_2_1": {
        "name": "Diminished (Whole-Half)",
        "source": "https://en.wikipedia.org/wiki/Octatonic_scale"
    },
    "3_1_1_1_3_1_1_1": {
        "name": "Spanish 8-Tone",
        "source": "https://en.wikipedia.org/wiki/Spanish_Phrygian_scale"
    },
    "2_2_2_2_2_2": {
        "name": "Whole Tone",
        "source": "https://en.wikipedia.org/wiki/Whole_tone_scale"
    },
    "1_3_1_1_3_1_2": {
        "name": "Phrygian Dominant",
        "source": "https://en.wikipedia.org/wiki/Phrygian_dominant_scale"
    },
    "1_3_1_2_1_2_2": {
        "name": "Double Harmonic Major",
        "source": "https://en.wikipedia.org/wiki/Double_harmonic_scale"
    },
    "2_1_3_1_1_2_2": {
        "name": "Neapolitan Minor",
        "source": "https://en.wikipedia.org/wiki/Neapolitan_scale#Neapolitan_minor_scale"
    },
    "1_2_2_2_1_2_2": {
        "name": "Neapolitan Major",
        "source": "https://en.wikipedia.org/wiki/Neapolitan_scale#Neapolitan_major_scale"
    },
    "3_1_2_1_3_2": {
        "name": "Persian Scale",
        "source": "https://en.wikipedia.org/wiki/Persian_scale"
    },
    "1_2_3_1_2_3": {
        "name": "Prometheus Scale",
        "source": "https://en.wikipedia.org/wiki/Prometheus_scale"
    },
    "2_2_2_1_1_2_2": {
        "name": "Lydian Dominant",
        "source": "https://en.wikipedia.org/wiki/Lydian_dominant_scale"
    },
    "1_2_2_2_2_1_2": {
        "name": "Phrygian Natural 6th",
        "source": "https://en.wikipedia.org/wiki/Dorian_♭2_scale"
    },
    "2_1_2_1_3_1_2": {
        "name": "Algerian Scale",
        "source": "https://en.wikipedia.org/wiki/Algerian_scale"
    },
    "1_1_3_2_1_1_3": {
        "name": "Arabian Scale",
        "source": "https://en.wikipedia.org/wiki/Hicaz_scale"
    },
    "2_2_1_1_2_2_2": {
        "name": "Balinese Scale",
        "source": "https://en.wikipedia.org/wiki/Pelog#Balinese_pelog"
    },
    "1_2_1_3_1_2_2": {
        "name": "Byzantine Scale",
        "source": "https://en.wikipedia.org/wiki/Double_harmonic_scale#Byzantine_scale"
    },
    "2_1_1_2_2_2_2": {
        "name": "Enigmatic Scale",
        "source": "https://en.wikipedia.org/wiki/Enigmatic_scale"
    },
    "1_1_2_2_2_2_2": {
        "name": "Flamenco Mode",
        "source": "https://en.wikipedia.org/wiki/Phrygian_dominant_scale#Flamenco_mode"
    },
    "3_1_1_2_3_2": {
        "name": "Gypsy Scale",
        "source": "https://en.wikipedia.org/wiki/Hungarian_minor_scale#Gypsy_scale"
    },
    "2_2_2_2_1_1_2": {
        "name": "Leading Whole Tone",
        "source": "https://en.wikipedia.org/wiki/Leading_whole_tone_scale"
    },
    "1_1_1_2_1_1_1_4": {
        "name": "Mohammedan Scale",
        "source": "https://en.wikipedia.org/wiki/Hicaz_scale#Related_scales"
    },
    "2_1_1_3_1_2_2": {
        "name": "Oriental Scale",
        "source": "https://en.wikipedia.org/wiki/Double_harmonic_scale#Oriental_scale"
    }
}